export default __webpack_public_path__ + "static/media/illustration-health-3-m@3x.8182a363.webp";